import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 64px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-bottom: 24px;
  }
`

export const Item = styled.div`
  width: calc(33.33% - 18px);
  margin-bottom: 24px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  &:after {
    content: "zobacz";
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 20px;
    color: #fff;
    font-weight: 700;
    transition: 0.2s opacity ease;
    opacity: 0;
  }
  .gatsby-image-wrapper {
    width: 100%;
  }
  &:hover {
    &:after {
      opacity: 1;
    }
  }
  &:not(:nth-child(3n)) {
    margin-right: 24px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    &:after {
      font-size: 14px;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    &:after {
      display: none;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    width: calc(50% - 6px);
    margin-bottom: 12px;
    &:not(:nth-child(3n)) {
      margin-right: 0px;
    }
    &:not(:nth-child(2n)) {
      margin-right: 12px;
    }
  }
`
